export function init($name) {
    const elem = $($name);

    if (!elem.length) {
        return;
    }

    $($name + '-second').change(function() {
        const parent = $(this).parents($name);
        const form = parent.parents('form');
        const oldName = parent.attr('data-current-name');
        const newName = parent.attr('data-next-name');

        if(this.checked || this.val) {
            $.each(parent.find($name + '-first'), function() {
                if (!oldName || !newName) {
                    $(this)
                        .removeAttr('required')
                        .parent()
                        .find('.form__group-errors')
                        .removeClass('filled')
                        .html('')
                        .parents('.form-input-group')
                        .removeClass('has-error');

                    if ($(this).hasClass('is-disabling-elem')) {
                        $(this).attr('disabled', 'disabled');
                    }
                } else {
                    if (!$(this).hasClass('js-dropdown-value')) {
                        $(this).val(form.find('[name="' + $(this).attr('name').replace(oldName, newName) + '"]').val());
                    } else {
                        $(this).parent().find('.js-dropdown-list').find('li[data-value="' + form.find('[name="' + $(this).attr('name').replace(oldName, newName) + '"]').val() + '"]').trigger('click');
                    }

                    $(this).parsley().validate();
                    form.find('[name="' + $(this).attr('name').replace(oldName, newName) + '"]').parsley().validate();
                }
            });
        } else {
            $.each(parent.find($name + '-first'), function() {
                if (!oldName || !newName) {
                    if ($(this).hasClass('is-required')) {
                        $(this).attr('required', 'required');
                    }

                    if ($(this).hasClass('is-disabling-elem')) {
                        $(this).removeAttr('disabled');
                    }
                }
            });
        }
    });
}
